import { render, staticRenderFns } from "./nestedSelect.vue?vue&type=template&id=2dc8179a"
import script from "./nestedSelect.vue?vue&type=script&lang=js"
export * from "./nestedSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports